/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_V2_Default_SpeedInputs */

const en_settings_v2_default_speed = /** @type {(inputs: Settings_V2_Default_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default speed`)
};

const es_settings_v2_default_speed = /** @type {(inputs: Settings_V2_Default_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad predeterminada`)
};

/**
* | output |
* | --- |
* | "Default speed" |
*
* @param {Settings_V2_Default_SpeedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_v2_default_speed = /** @type {((inputs?: Settings_V2_Default_SpeedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_V2_Default_SpeedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_v2_default_speed(inputs)
	return en_settings_v2_default_speed(inputs)
});